<template>
  <div class="home" @click="windowClick">
    <!-- <header class="header">
      <p class="close">×</p>
      <p>全国共享员工实时动态数据库</p>
      <p>
        <span></span><span></span><span></span>
      </p>
    </header> -->
    <section class="section">
      <div class="banimg">
        <!-- <p class="qiuzhuBtn" @click="flex">企业用人求助 ></p> -->
        <div class="blankLink">
        <p class="activeOne" @click="selectWitch">您在{{itemext1}} ></p>
        <p class="activeTwo" @click="polcy">疫情期全国用工政策实时查阅 ></p>
        </div>
      </div>
      <div class="navbar">
        <div class="dataEcharts" v-show="showEcharts">
          <!-- <div class="topTitle">城市共享员工总量排行榜TOP5</div> -->
          <!-- <div class="xuhao">
            <p v-for="(item,index) in cityData" :key="index">{{index+1}}</p >
          </div> -->
           <!-- <Map :listMap='listMap'  v-if="listMap.length" /> -->
          <!-- <div id="echarts" class='echarts'  :style="{width: '100%', height: '180px'}"></div> -->
        </div>
        <van-tabs v-model="activeName"  @click="onClick" color='#3A6CE1'>
          <!-- <van-tab title="实时动态" name="0">内容 1</van-tab> -->
          <van-tab title="实时动态" name="0"  >
            <div class="boxTop">
              <p class="date">截止<span>2020-02-20</span>全国数据统计</p>
                <div class="total">
                  <div class="lists">
                  <div class="items">
                      <p style="color:#2B3E4F;font-size:10px;font-weight:500">比昨日:+<span style="color:#FF2828;font-size:10px;font-weight:500"> {{homeData.totalShareUpper}}</span></p>
                      <p style="color:#FF2828;font-size:18px;font-weight:500;padding:15px 0;text-align:center">{{homeData.totalShare}}</p>
                      <p style="color:#2B3E4F;font-size:12px;font-weight:500">共享员工总数</p>
                  </div>
                </div>
                <div class="lists">
                  <div class="items">
                      <p style="color:#2B3E4F;font-size:10px;font-weight:500">比昨日:+<span style="color:#FE8F2B;font-size:10px;font-weight:500"> {{homeData.needCountUpper}}</span></p>
                      <p style="color:#FE8F2B;font-size:18px;font-weight:500;padding:15px 0;text-align:center">{{homeData.needCount}}</p>
                      <p style="color:#2B3E4F;font-size:12px;font-weight:500">需求总人数</p>
                  </div>
                </div>
                <div class="lists">
                  <div class="items">
                      <p style="color:#2B3E4F;font-size:10px;font-weight:500">比昨日:+<span style="color:#1EC736;font-size:10px;font-weight:500"> {{homeData.matchSuccessUpper}}</span></p>
                      <p style="color:#1EC736;font-size:18px;font-weight:500;padding:15px 0;text-align:center">{{homeData.reviewCountUpper}}</p>
                      <p style="color:#2B3E4F;font-size:12px;font-weight:500">匹配成功</p>
                  </div>
                </div>
                <div class="lists">
                  <div class="items">
                      <p style="color:#2B3E4F;font-size:10px;font-weight:500">比昨日:+<span style="color:#4F0E64;font-size:10px;font-weight:500"> {{homeData.matchSuccess}}</span></p>
                      <p style="color:#4F0E64;font-size:18px;font-weight:500;padding:15px 0;text-align:center">{{homeData.reviewCount}}</p>
                      <p style="color:#2B3E4F;font-size:12px;font-weight:500">总访问人数</p>
                  </div>
                </div>
            </div>
            </div>
            <Map :listMap='listMap'  v-if="listMap.length" class="map"/>
          </van-tab>
          <van-tab title="公益需求" name="1">   
            <!-- <div class="tit">公益需求<span class="detail">数据来源：人力资源与社会保障部</span></div> -->
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pubWarpContainer">
            <!-- <div class="tit">公益需求<span class="detail">数据来源：人力资源与社会保障部</span></div> -->
            <div v-for="(item) in castLists" :key="item.id" class="pubWarp" border >
              <!-- <van-cell-group border> 
                 <van-cell :title="item.compname" is-link  @click="pubWelfare(item)" /> 
              </van-cell-group> -->
                <van-row  @click="pubWelfare(item)" class="xuqiuWarp"> 
                 <van-col span='1' class="xuqiuIcon1" > <van-icon name="stop" /></van-col> 
                 <van-col span='21' class="xuqiuTit">{{item.compname}} </van-col>
                 <van-col span='2'  class="xuqiuicon"> <van-icon name="arrow" /></van-col>
                </van-row>
                <van-row type="flex" class="address">
                  <van-col span="24" class="pubAddress" >{{item.itemext1}}</van-col>
                </van-row>
                 <van-row type="flex">
                  <van-col span="8" class="pubDate" ><span class="pubDateCon">租用时长：{{item.worktime}}个月</span></van-col>
                  <van-col span="8" class="pubDate" ><span class="pubDateCon">需求数量：{{item.needcount}}</span></van-col>
                </van-row>
                <van-row type="flex">
                  <van-col span="8" class="pubDate" ><span class="pubDateCon">行业：{{item.industry}}</span></van-col>
                </van-row>
            </div>
            </van-pull-refresh>        
          </van-tab>
          <van-tab title="企业用工" name="2">
            <!-- <div class="tit">企业需求<span class="detail">数据来源：人力资源与社会保障部</span></div> -->
             <van-pull-refresh v-model="isLoading" @refresh="onRefreshEmploy" class="pubWarpContainer">
                <div v-for="(item) in compLists" :key="item.id" class="pubWarp">
                  <!-- <van-cell :title="item.compname" is-link  @click="pubWelfare(item)" /> -->
                  <!-- <div class="pubTit" >企业名称企业名称企业名称企业名称</div> -->
                   <van-row  @click="pubWelfare(item)" class="xuqiuWarp"> 
                    <van-col span='1' class="xuqiuIcon1" > <van-icon name="stop" /></van-col> 
                    <van-col span='21' class="xuqiuTit">{{item.compname}} </van-col>
                    <van-col span='2'  class="xuqiuicon"> <van-icon name="arrow" /></van-col>
                    </van-row>
                    <van-row type="flex" class="address">
                      <van-col span="24" class="pubAddress" >{{item.itemext1}}</van-col>
                    </van-row>
                    <van-row type="flex">
                      <van-col span="8" class="pubDate" ><span class="pubDateCon">租用时长：{{item.worktime}}个月</span></van-col>
                      <van-col span="8" class="pubDate" ><span class="pubDateCon">需求数量：{{item.needcount}}</span></van-col>
                    </van-row>
                    <van-row type="flex">
                      <van-col span="8" class="pubDate" ><span class="pubDateCon">行业：{{item.industry}}</span></van-col>
                    </van-row>
                </div>
              </van-pull-refresh>      
          </van-tab>
          <van-tab title="企业共享" name="3">
             <van-pull-refresh v-model="isLoading" @refresh="onRefreshTime" class="pubWarpContainer">
              <div v-for="(item) in compListsEmploy" :key="item.id" class="pubWarp">
                <!-- <van-cell :title="item.compname" is-link  @click="pubWelfare(item)" /> -->
                <!-- <div class="pubTit" >企业名称企业名称企业名称企业名称</div> -->
               <van-row  @click="pubWelfareComp(item)" class="xuqiuWarp"> 
                 <van-col span='1' class="xuqiuIcon1" > <van-icon name="stop" /></van-col> 
                 <van-col span='21' class="xuqiuTit">{{item.compname}} </van-col>
                 <van-col span='2'  class="xuqiuicon"> <van-icon name="arrow" /></van-col>
                </van-row>
                <van-row type="flex" class="address">
                  <van-col span="24" class="pubAddress" >{{item.itemext1}}</van-col>
                </van-row>
                 <van-row type="flex">
                  <van-col span="8" class="pubDate" ><span class="pubDateCon">共享时长：{{item.sharetime}}个月</span></van-col>
                  <van-col span="8" class="pubDate" ><span class="pubDateCon">共享人数：{{item.needcount}}</span></van-col>
                </van-row>
              </div>
              </van-pull-refresh>
            <!-- <div class="tabs-broadcast">
            <div class="tit">用工播报 <span class="detail">数据来源：人力资源与社会保障部</span></div>
              <van-pull-refresh v-model="isLoading" @refresh="onRefreshTime">
              <div class="cast-list">
                <div v-for="(item,index) in castList" :key="item.id" class="cast-item">
                  <div class="dot"></div>
                  <div class="vertical-line"></div>
                  <p class="time">
                    <span class="duration">{{item.timeAgo}}</span>
                    {{item.creattime }}
                  </p>
                  <div class="content-block">
                    <div class="title">
                      <span class="new-tag" v-if="index==0">最新</span>
                      {{item.title}}
                    </div>
                    <div class="content">{{item.content}}</div>
                    <div class="bottom"> -->
                        <!-- <div
                        v-if="item.CircleURL"
                        @click="joinGroup(item.CircleURL)"
                        class="btns"
                      >加入{{item.ProvinceName}}防疫社群</div> -->
                      <!-- <div @click="goSource(item.SourceURL)" class="source">信息来源：{{item.newsfrom}}</div>
                    </div> -->
                      <!-- <div
                        v-if="item.CircleURL"
                        @click="joinGroup(item.CircleURL)"
                        class="btns"
                      >加入{{item.ProvinceName}}防疫社群</div>
                      <div @click="goSource(item.SourceURL)" class="source">信息来源：{{item.InfoSource}}</div>
                    </div> -->
                  <!-- </div>
                </div>
              </div>
                 </van-pull-refresh>  
            </div> -->
           </van-tab>
        </van-tabs>
          <van-dialog
            use-slot
            v-model='shows'
            bind:close="onClose"
          >
          <div class="companyTit">
            <div class="companyDiv">
              <div class="titHeader"><span class="titBolck"></span>{{nowDetailData.compname}}</div>
              <div class="titDetal"><span class="titDt">工作时长</span><span>{{nowDetailData.worktime}}个月</span></div>
              <div class="titDetal"><span class="titDt">联系人</span><span>{{nowDetailData.contacter}}</span></div>
              <div class="titDetal"><span class="titDt">需求人数</span><span>{{nowDetailData.needcount}}人</span></div>
              <div class="titDetal"><span class="titDt">联系电话</span> <span class="phoneBlock" @click="getPhone"  v-if="!localPhone">点击获取</span> <span v-else>{{phoneNum}}</span></div>
              <div class="titDetal"><span class="titDt">所在区域</span><span>{{nowDetailData.itemext1}}</span></div>
              <div class="titDetal"><span class="titDt">行业</span><span>{{nowDetailData.industry}}</span></div>
              <div class="titDetal"><span class="titDt">工种</span><span>{{nowDetailData.jobtype}}</span></div>
            </div>
            <div>
              <div class="titContent">工作内容</div>
              <div class="cover12">{{nowDetailData.workdetail}}</div> 
            </div>
          </div>
          </van-dialog>
          <!-- 企业共享 -->
           <van-dialog
            use-slot
            v-model='showsCompany'
            bind:close="onClose"
          >
          <div class="companyTit">
            <div class="companyDiv">
              <div class="titHeader"><span class="titBolck"></span>{{nowDetailData.compname}}</div>
              <div class="titDetal"><span class="titDt">共享时长</span><span>{{nowDetailData.sharetime}}个月</span></div>
              <div class="titDetal"><span class="titDt">联系人</span><span>{{nowDetailData.contacter}}</span></div>
              <div class="titDetal"><span class="titDt">共享人数</span><span>{{nowDetailData.needcount}}</span></div>
              <div class="titDetal"><span class="titDt">联系电话</span> <span class="phoneBlock" @click="getPhone"  v-if="!localPhone">点击获取</span> <span v-else>{{phoneNum}}</span></div>
              <div class="titDetal"><span class="titDt">所在区域</span><span>{{nowDetailData.itemext1}}</span></div>
              <div class="titDetal"><span class="titDt">工种</span><span>{{nowDetailData.jobtype}}</span></div>
            </div>
          </div>
          </van-dialog>
          <!-- 获取电话的表单 -->
           <van-dialog
            use-slot
            v-model='showsPhone'
            bind:close="onClose"
            show-cancel-button
            :beforeClose="ok"
          >
            <van-row class="phoneFrom"> 
              <van-cell-group > 
                  <van-field clickable required label="联系电话" placeholder="请填写联系电话" v-model="phoneNum" />
              </van-cell-group > 
            </van-row>
          </van-dialog>
          <van-overlay :show="importPag" @click="importPag = false">
            <div class="wrapper" @click.stop>
              <!-- <div class="block" /> -->
              <img :src='jiaotou' class="icojiaotou" />
              <p class="icotxt" >点击右上角按钮分享</p>
            </div>
          </van-overlay>
          <van-popup v-model="showdiqu" position="bottom">
            <van-area
              :area-list="areaList"
              v-model="itemext1"
              @confirm="areaConfirm"
              @cancel="areaCancel"
            />
          </van-popup>
        <!-- </van-popup> -->
        <!-- <ul id="main">
          <li><router-link  to="/Home/a">实时动态</router-link></li>
          <li><router-link  to="/Home/b">公益需求</router-link></li>
          <li><router-link  to="/Home/c">企业需求</router-link></li>
          <li><router-link  to="/Home/d">用工播报</router-link></li>
        </ul>  -->
          <!-- 路由匹配到的组件将显示在这里 -->
        <!-- <router-view></router-view> -->
      </div>
    </section>
     <!-- <van-dropdown-menu direction="up" >
        <van-dropdown-item v-model="value1" :options="option1" title="筛选"/>
      </van-dropdown-menu> -->
    <ul class="selectWarp" v-if="selectP===true">
        <li @click="selectEmp" >用工需求 <span >></span></li> 
        <li @click="selectShare" >共享需求  <span>></span></li>
        <li @click="selectOther"> 其他需求 <span >></span></li>
      </ul>
    <footer class="footer">
        <div class="shareWrapper">
        <img :src='tupiao' class="icoShare"  @click="importPag = true"/>
        <span >分享</span>
        </div>
        <button @click.stop="need">企业需求</button> 
        <button @click="share" >成为共享员工</button>
    </footer>
  </div>
</template>

<script>
// import A from '@/components/child/A.vue'; dataCount
import { broadcast,complist,cClick,reCheck,dataCount,getAreass} from "../api/test"
import "echarts/map/js/china.js";
import Map from './index.vue'
import axios from 'axios'

export default {
  name:"home",
  components: {Map},
  data() {
    return {
      selectP:false,
       option1: [
        { text: '用工需求', value: 0 },
        { text: '共享需求', value: 1 },
        { text: '其他需求', value: 2 }
      ],
      value1:1111,
      showEcharts:true,
      isLoading:false,
      count:1,
      countTime:1, 
      countEmploy :1,
      shows:false,
      showsCompany:false,
      activeName: '0',
      activeKey:0,
      castLists:[],
      imgUrl:'',
      compLists :[], 
      castList:[],
      compListsEmploy:[],
      nowDetailData:{},
      showsPhone:false,
      phoneNum:'',
      compnames:'',
      homeData:"",
      topCity:"",
      type:'',
      workerIds:'',
      listId:'',
      localPhone:false,
      cityCount:"",
      cityData:[] ,// 进度条序号
      listMap:[],
      tupiao:'',
      jiaotou:'',
      importPag:false,
      showdiqu: false,
      itemext1:'北京市',
      areaList:[]
    };
  },

  mounted(){
  },
  methods: {
    selectWitch() {
      this.showdiqu = true;
    },
    getAreaList() {
      var params = {};
      getAreass("/getArea", params).then(res => {
        this.areaList = eval("(" + res.data + ")");
      });
    },
    areaConfirm(val) {
      this.showdiqu = false;
      this.itemext1 = val[1].name;
      this.cityCode = val[0].code;
    },
    areaCancel() {
      this.showdiqu = false;
    },
    getData(){
      var params={};
      dataCount("/dataCount",params).then(res=>{
        if (res.data) {
          this.homeData = res.data.countData;
          this.cityData = res.data.topCitys;
          this.listMap=res.data.topCitys
        }
      })
    },
     
    getMaxSort(arr) {
      var min;
      for(var i=0; i<arr.length; i++){
          for(var j=i; j<arr.length;j++){
              if(arr[i]>arr[j]){
                min=arr[j];
                arr[j]=arr[i];
                arr[i]=min;
              }
          }
      }
    },

    pubWelfareComp(item){
       this.localPhone=false
      this.phoneNum= ''
      this.showsCompany=true
      this.nowDetailData=item
      this.listId= item.id
      // 获取 workerId 如果有，0 如果没有  compId：如果有，1 如果没有 type 重新
     let storage = window.localStorage;
     const workerId = JSON.parse(storage.getItem('workerId'));
     const compId = JSON.parse(storage.getItem('compId'));
      if(workerId&&!compId){
        this.type=0;
        this.workerIds=workerId;
      } else if(compId&&!workerId){
         this.type=2;
         this.workerIds=compId;
      } else if(compId&&workerId){
         this.type=0;
         this.workerIds=workerId;
      }else{
        this.type=0;
        this.workerIds=-1
      }
      cClick('/cClick',{
        workerId:this.workerIds,
        compId:item.id, // 只穿列表id
        type:this.type,
      }).then(res=>{
        console.log('接口5',res)
    
      })
    },
   pubWelfare(item){
      this.shows=true
      this.localPhone=false
      this.phoneNum= ''
      this.nowDetailData=item
      this.listId= item.id
      // 获取 workerId 如果有，0 如果没有  compId：如果有，1 如果没有 type 重新
     let storage = window.localStorage;
     const workerId = JSON.parse(storage.getItem('workerId'));
     const compId = JSON.parse(storage.getItem('compId'));
      if(workerId&&!compId){
        this.type=0;
        this.workerIds=workerId;
      } else if(compId&&!workerId){
         this.type=2;
         this.workerIds=compId;
      } else if(compId&&workerId){
         this.type=0;
         this.workerIds=workerId;
      }else{
        this.type=0;
        this.workerIds=-1
      }
      cClick('/cClick',{
        workerId:this.workerIds,
        compId:item.id, // 只穿列表id
        type:this.type,
      }).then(res=>{
        console.log('接口5',res)
      })
    },
    share() {
      this.$router.push("/ShareEmploy");
    },
     need() {
      if(this.selectP){
        this.selectP=false
      }else{
        this.selectP=true 
      }
    },
    windowClick() {
      this.selectP = false
    },
    polcy() {
      this.$router.push("/polyDetail");
    },
    flex() {
      this.$router.push("/FlexEmploy");
    },
    selectEmp () {
      this.$router.push("/NeedEmploy");
    },
    selectShare () {
      this.$router.push("/SharedDemand");
    },
    selectOther() {
      this.$router.push("/FlexEmploy");
    },
    // 公益
    onRefresh(){
        this.count++;
        this.isLoading=true
        complist('/compList',{
          pageNum:this.count,
          pageSize:10,
          type:0,
          city:110000,
        }).then(res=>{
          this.castLists=res.data&&res.data.list
          this.isLoading=false
        })
    },
    // 企业
    onRefreshEmploy(){
        this.countEmploy++;
        this.isLoading=true
         complist('/compList',{
            pageNum:this.countEmploy,
            pageSize:10,
            type:1,
             city:110000,
          }).then(res=>{
            this.compLists=res.data&&res.data.list
            this.isLoading=false
          })
    },
    // 企业共享
    onRefreshTime(){ 
        this.countTime++;
        this.isLoading=true
         broadcast('/compShareList',{
            pageNum:this.countTime,
            pageSize:10,
       city:110000,
          }).then(res=>{
              this.compListsEmploy=res.data.list
              this.isLoading=false
          })
    },
    getPhone(){
      let storage = window.localStorage;
      const workerId = JSON.parse(storage.getItem('workerId'));
      const compId = JSON.parse(storage.getItem('compId'));
      if(workerId&&!compId){
        this.type=1;
        this.workerIds=workerId;
      } else if(compId&&!workerId){
         this.type=3;
         this.workerIds=compId;
      } else if(compId&&workerId){
         this.type=1;
         this.workerIds=workerId;
      }
      // 如果有  //  后台返回 workerId 在reCheck里 ，compId？
      if(this.nowDetailData.phonenum){
        cClick('/cClick',{
            workerId:this.workerIds, 
            compId: this.listId, // 
            type: this.type,
          }).then(res=>{
              console.log('接口5',res)
              this.localPhone=true
              this.phoneNum= this.nowDetailData.phonenum
          })
      }else{
         this.showsPhone=true
      }
    },
    ok(action, done){
     // phoneNum 从表单中获取 
      if (action === 'confirm') {
        if(this.nowDetailData.phonenum){
            reCheck('/reCheck',{
              phoneNum:this.nowDetailData.phonenum,
            }).then(res=>{
              if(res.code==="0"){
                  this.workerIds=res.data&&res.data.id
                  this.type=res.data&&res.data.role==='comp'?3:1;
                   cClick('/cClick',{
                    workerId:this.workerIds, 
                    compId: this.listId, // 
                    type: res.data.role==='comp'?3:1,
                  }).then(res=>{
                      console.log('接口5',res)
                  })
              }else{
                this.$toast(res.msg);
              }
          })
          this.showsPhone=false
          this.phoneNum=''
          done();
        } else{
          done(false) 
          this.$toast('请填写手机号');
        }
      } else {
        done();
         this.showsPhone=false
      }
    },
    onClick(name){
      if(+name===0){
       this.showEcharts=true
      }else{
        this.showEcharts=false
      }
    },
   

  },
  created() {
    let url
    if(process.env.NODE_ENV === 'development') {
      url = "/api/init"
    } else {
      url = "/app/init"
    }
    axios.post(url,{  
    }).then((res)=> {
      if(Number(res.data.code) === 0){
        let storage=window.localStorage;
        let tokenInfo =res.data.data
        storage.setItem('tokenInfo',JSON.stringify(tokenInfo))
        this.getData()
        this.getAreaList()
        // zj 后三个接口  count:1, countTime:1, countEmploy :1,
        // 企业共享
        broadcast('/compShareList',{
            pageNum:this.countTime,
            pageSize:10,
            city:110000,
          }).then(res=>{
          this.compListsEmploy=res.data&&res.data.list
          })
          // 公益  compLists :[], 
          complist('/compList',{
            pageNum:this.count,
            pageSize:10,
            type:0,
            city:110000,
          }).then(res=>{
            this.castLists=res.data&&res.data.list
          })
          // 企业
        complist('/compList',{
            pageNum:this.countEmploy,
            pageSize:10,
            type:1,
            city:110000,
          }).then(res=>{
            this.compLists=res.data&&res.data.list
          })

      }
    })
    this.imgUrl = require("./../assets/iocn.png");
    this.tupiao= require("./../assets/shares.png");
    this.jiaotou=require("./../assets/jiaotou.png");
  }
}; 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.shareWrapper{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  margin-left:18px
}
.shareWrapper span{
  display:block;
  font-size:12px
}
.icoShare{
  width: 22px;
  height: 22px
}

.boxTop {
   width:100%;
   height:144px;
   background:#fff;
   margin-top:8px;
}
.boxTop .date {
  font-size:12px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(140,140,140,1);
  line-height:13px;
  padding:20px 0 19px 15px;
}
.boxTop .total {
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:0 15px;
}
.home{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F6F3F7;
}
.header{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background: #fff;
}
.header p{
  font-size: 18px;
  color: #333333;
}
.header .close{
  font-size: 22px;
}
.banimg{
  width: 100%;
  height: 330px;
  background-image: url(../assets/ban.png);
  background-repeat: no-repeat;
  background-size: 100% 100% ;
  position: relative;
}
.qiuzhuBtn{
  width:110px;
  height:32px;
  position: absolute;
  right: 0;
  top: 20px;
  text-align: center;
  line-height: 32px;
  background:linear-gradient(0deg,rgba(255,144,42,1),rgba(255,185,30,1));
  border-radius:32px 0px 0px 32px;
  font-size: 12px;
  color: #fff;
}
.blankLink{
  position:relative;
  top:266px;
  left:20px
}
.activeOne {
  height:34px;
  background:rgba(30,48,110,1);
  border-radius:5px;
  padding:0 10px;
  text-align: center;
  line-height: 34px;
  font-size: 12px;
  color: #fff;
  display:inline-block;
  margin-right:12px
}
.activeTwo {
  display:inline-block;
  padding:0 10px;
  height:34px;
  background:rgba(30,48,110,1);
  border-radius:5px;
  
  text-align: center;
  line-height: 34px;
  font-size: 12px;
  color: #fff;
}
.section{
  width: 100%;
  flex-grow:1;
  overflow-y: scroll;
  overflow-x: hidden
}
.footer{
  width:100%;
  height: 70px;
  border-top: solid 1px #cccc;
  background: #fff;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.footer button{
  width: 40%;
  height: 40px;

  outline: none;
  border: 0;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
}
// .selectFooter{
//   width: 40%;
//   height: 60px;
//   margin-left: 3%;
//   margin-top: 5px;
//   outline: none;
//   border: 0;
//   border-radius: 5px;
//   color: #fff;
//   font-size: 14px;
//   background: #6987FE;
//   display: inline-block;
// }
// .selectFooters{
//    width: 40%;
//   height: 40px;
//   margin-left: 3%;
//   margin-top: 5px;
//   outline: none;
//   border: 0;
//   border-radius: 5px;
//   color: #fff;
//   font-size: 14px;
// background: #FE6766;
// display: inline-block;
// }
.footer button:nth-child(2){
   background: #6987FE;
   width:128px
  //  background: #FE6766;
}
.footer button:nth-child(3){
  width:157px;
  background: #FE6766;
  margin-right:18px
}
#main{
  width: 100%;
  height: auto;
  display: flex;
  background: #fff;
  margin-bottom: 10px;
}
#main li{
  width: 25%;
  height: 40px;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
}
.navbar{
  width: 100%;
  height: 100px;
  position: relative;
}
  .tit{
    height: 50px;
    width: 100%;
    border-left-width:4px;
    border-left-color: #396CE1;
    border-left-style:solid;
    font-size: 16px;
    background-color: #fff;
    color: #000;
    line-height: 50px;
    padding-left: 15px;
    margin-top: 8px
  }
  .detail{
    color: #8C8C8C;
    font-size:12px;
    position:absolute;
    right: 15px

  }
  .companyDiv{
    margin-bottom: 37px
  }
  .titHeader{
    margin-bottom:31px;
    font-size: 15px;
    font-weight:bold

  }
  .titDetal{
    height: 28px;
    line-height:28px;
    color: #262626;
  }
  .titDt{
    display: inline-block;
    margin-right: 13px
  }
  .phoneBlock{
     height: 12px;
     line-height:13px;
     display: inline-block;
     width:60px;
    // height:16px;
    // // font-size:12px;
    // // font-weight:bold;
    // // color:rgba(38,38,38,1);
    // // line-height:16px;
    text-align: center;
    border:1px solid rgba(77,77,77,1);
    border-radius:7px;
    // margin-top: 4px;
    font-size: 9px;
  }
  .companyTit{
    padding-top: 35px;
    padding-left: 24px;
  }
  .titDetal{
    color: #262626;
    font-size:12px
  }
  .titContent{
    margin-bottom: 14px;
    color:  #191414;
    font-size: 12px;
    font-weight:bold
  }
  .cover12{
  font-size: 12px;
   white-space:normal;
    word-break:break-all;
    word-wrap:break-word;
  }
  .titBolck{
    width:4px;
    height:4px;
    background:rgba(81,81,81,1);
    display: inline-block;
    margin-right:4px;
    margin-bottom:2px
  }
  .phoneFrom{
    padding-top:8px;
    padding-left: 8px
  }
  .pubWarpContainer {
    padding: 9px 15px 0;
  }
  .pubWarp{
    margin-bottom: 10px;
    background-color: #fff;
    padding-left: 16px;
    padding-top:17px;
    padding-bottom:14px
  }
  .address {
    margin-bottom: 13px;
  }
  .pubTit {
    color: #262626;
    font-size:13px;
  }
  .pubAddress {
    color: #595959;
    font-size: 14px;
  }
  .pubDate {
    color: #585858;
    font-size:12px;
    margin-bottom: 6px;
  }
  .pubDateCon {
    display: inline-block;
    padding: 0 6px;
    height: 20px;
    line-height: 20px;
    background-color: #F2F2F2;
    border-radius: 2px;
  }
  .pub{
    position: relative;   
  }
   .xuqiuTit{
        font-size: 15px;
        font-weight:bold;
        color: #333;
    }
    .xuqiuicon{
      font-size: 14px;
      color: #BFBFBF
    }
    .xuqiuIcon1{
       font-size: 10px;
      color: #515151;
      margin-top: 6px
    }
    .xuqiuWarp{
      border-bottom-color: #D9D9D9;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      padding-bottom: 6px;
      margin-bottom:13px
    }
  .pubSum{
    color: #808080;
    font-size:12px;
    text-align: center
  }
.tabs-broadcast {
  width: 100%;
  background-color: #f2f2f2;

  .cast-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    padding: 16px 16px 0 0;
    .cast-item {
      width:e("calc(100% - 46px)");
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      margin-left: 30px;
      position: relative;
      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ff3654;
        position: absolute;
        top: 5px;
        left: -19px;
        z-index: 2;
      }
      .vertical-line {
        width: 2px;
        height: 100%;
        background-color: #e0e0e0;
        position: absolute;
        top: 4px;
        left: -15px;
        z-index: 1;
      }
     
      // .info {
      //   flex: 1;
      //   height: 100%;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: flex-start;
      //   align-items: flex-start;
      .time {
        margin-top: 0;
        font-size: 12px;
        color: #999;
        .duration {
          font-size: 13px;
          color: #333;
          margin-right: 5px;
        }
      }
      .content-block {
        width: 100%;
        border-radius: 5px;
        background-color: white;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 10px 16px;
        .title {
          display: inline-block;
          font-size: 13px;
          margin-bottom: 8px;
          .new-tag {
            display: inline-block;
            width: 30px;
            height: 18px;
            font-size: 12px;
            border-radius: 2px;
            text-align: center;
            line-height: 18px;
            color: white;
            background: linear-gradient(0deg,rgba(255,144,42,1),rgba(255,185,30,1));
            margin-right: 3px;
          }
        }
        .content {
          color: #999;
          font-size: 12px;
          white-space: wrap;
          text-overflow: ellipsis;
          margin-bottom: 20px;
        }
        .bottom {
          width: 100%;
          .btns {
            display: inline-block;
            float:left;
            font-size: 12px;
            color: #2482ea;
          }
          .source {
            display: inline-block;
            float: left;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }
}
.dataEcharts{
  width:100%; 
  height:170px;
  background: #fff;
  position:absolute;
  top:250%;
  left:0;
  margin-top:11px;
}
.topTitle{
  width:328px;
  height:23px;
  font-size:13px;
  font-family:PingFang SC;
  font-weight:700;
  color:rgba(38,38,38,1);
  line-height:26px;
  margin-left: 5%;
}
.xuhao{
  position: absolute;
  left: 5%;
  top: 37px;
}
.xuhao p{
  width: 12px;
  height: 12px;
  // line-height: 26px;
  font-size: 10px;
  text-align: center;
  line-height: 13px;
   margin-bottom: 10.5px;
}

.xuhao p:nth-child(1){
  width: 12px;
  height: 12px;
  background: #F27345;
  color: #fff;
 
}
.xuhao p:nth-child(2){
   width: 12px;
  height: 12px;
  background: #41AEE7;
  color: #fff;
}
.xuhao p:nth-child(3){
   width: 12px;
  height: 12px;
  background: #33C491;
  color: #fff;
}
.xuhao p:nth-child(4){
    margin-bottom: 9px;
}
.icojiaotou{
  width: 130px;
  height: 150px;
  position:absolute;
  top:25px;
  right: 33px;
}
.icotxt{
  color: #fff;
  font-size: 13px;
  position:absolute;
  top:196px;
  right: 87px;
}
.selectWarp{
background:rgba(255,255,255,1);
border:2px solid rgba(95,128,249,1);
box-shadow:0px 3px 10px 0px rgba(105,135,254,0.3), 0px -3px 10px 0px rgba(105,135,254,0.3);
border-radius:8px;
  position: absolute;
  bottom: 60px;
  left:12%;
  text-align: center;
  padding:0 12px 0 26px
}
.selectWarp li{
  height: 41px;
  line-height: 41px;
  // width: 40%;
  font-size: 14px;
  color: #5277F3
 
}
.selectWarp li span {
  display:inline-block;
  margin-left: 25px
 
}
.van-dialog {
  border-radius: 9px;
}
.map{
  margin-top:8px;
  margin-bottom:8px;
}
</style>